module.exports = __webpack_public_path__ + "img/one-line-dark.41a61e43.svg";